<template>
  <div>
    <div class="border px-3 pb-2 pt-3 rounded bg-gray mb-2">
      <div class="d-flex align-items-center mb-2">
        <AppLabel class="mr-auto mb-0 pb-0">Base Value:</AppLabel>
        <AppButton
          v-if="!disabled"
          class="shadow-none"
          raised
          @click="resolve(baseValue)"
        >
          Resolve with base value
        </AppButton>
      </div>
      <div class="border px-2 py-1 mb-2 border-opaque bg-white" data-test="diff-base">
        <slot name="base" v-bind="baseValue" />
      </div>
    </div>

    <div class="border px-3 pb-2 pt-3 rounded bg-anakiwa mb-2">
      <div class="d-flex align-items-center mb-2">
        <AppLabel class="mr-auto mb-0 pb-0">Current Value:</AppLabel>
        <AppButton
          v-if="!disabled"
          class="shadow-none"
          raised
          @click="resolve()"
        >
          Resolve with current value
        </AppButton>
      </div>
      <div class="border px-2 py-1 mb-2 border-opaque bg-white" data-test="diff-current">
        <slot name="current" />
      </div>
    </div>

    <div v-if="diffs && diffs.length">
      <AppLabel>Alternative Values:</AppLabel>
      <div
        v-for="(diff, index) of diffs"
        :key="index"
        class="border px-3 pb-2 pt-3 rounded mb-2"
      >
        <div class="d-flex align-items-center mb-2">
          <AppLabel class="mr-auto mb-0 pb-0">
            <div v-html="diff.label" />
          </AppLabel>
          <div v-if="!disabled">
            <AppButton
              v-if="isDifferentThanCurrent(diff)"
              class="btn-sm bg-light"
              @click="resolve(diff)"
            >
              Resolve With This Value
            </AppButton>
            <AppButton
              v-else
              disabled
              class="btn-sm"
              @click="resolve(diff)"
            >
              Same as current value
            </AppButton>
          </div>
        </div>

        <div class="border px-2 py-1 mb-2 border-opaque bg-white">
          <slot name="diff" v-bind="diff" />
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { isValueEqual } from '@/utils/value'

export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    diffs: {
      type: Array,
      required: true,
    },
    currentValue: {
      type: [ Boolean, Array, Object, String, Number ],
      required: false,
    },
    baseValue: {
      type: Object,
      default: () => ({}),
    },
  },
  setup (props, { emit }) {
    function resolve (diff) {
      emit('resolve', diff)
    }
    function isDifferentThanCurrent (diff) {
      return !isValueEqual(props.currentValue, diff.value)
    }

    return {
      isDifferentThanCurrent,
      resolve,
    }
  },
}
</script>

<style scoped>
.bg-anakiwa {
  background-color: #c3e1fc;
}
.border-opaque {
  border-color: #00000010 !important;
}
</style>
